import React, { createContext } from 'react'

type Category = 'toyama' | 'niigata'

interface OwnProps {
  children: React.ReactNode
  category: Category
}

export const CategoryContext = createContext<Category>('' as Category)

const CategoryProvider = (props: OwnProps) => {
  return (
    <CategoryContext.Provider value={props.category}>
      {props.children}
    </CategoryContext.Provider>
  )
}

export default CategoryProvider
